import { motion, AnimatePresence } from 'framer-motion';

/**
 * Animation flottante "+10 XP" qui monte et fade out.
 * Affiché en overlay au-dessus du contenu quand l'utilisateur gagne de l'XP.
 */
export default function XpGainToast({ amount, show, onDone }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="xp-gain"
          data-testid="xp-gain"
          initial={{ opacity: 0, y: 30, scale: 0.5 }}
          animate={{ opacity: 1, y: -100, scale: 1.1 }}
          exit={{ opacity: 0, y: -180 }}
          transition={{ duration: 1.5, ease: 'easeOut' }}
          onAnimationComplete={onDone}
          className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[60] pointer-events-none">
          <div className="bg-gradient-to-r from-yellow-400 to-amber-500 text-slate-950 font-black text-3xl px-6 py-3 rounded-full shadow-2xl shadow-yellow-500/50 flex items-center gap-2">
            ⚡<span>+{amount} XP</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
